import React from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import './style/collapse.less';
var Header = function (props) {
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-collapse-item-header");
    var avatar = props.avatar, title = props.title, subTitle = props.subTitle, tag = props.tag, disabled = props.disabled;
    // 如果element有disabled的属性，且为true，那就用他自己的disabled样式
    var renderElement = function (element) {
        var _a;
        if (!disabled || (React.isValidElement(element) && ((_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.disabled)))
            return element;
        return React.createElement("span", { className: "".concat(prefixCls, "-element-disabled") }, element);
    };
    var handleOnFocus = function (e) {
        e.stopPropagation();
    };
    return (React.createElement("div", { className: prefixCls },
        React.createElement("input", { type: "checkbox", disabled: Boolean(disabled) }),
        React.createElement("div", { onFocus: handleOnFocus, className: "".concat(prefixCls, "-area") },
            avatar && React.createElement("div", { className: "".concat(prefixCls, "-avatar") }, renderElement(avatar)),
            React.createElement("div", null,
                React.createElement("div", { className: "".concat(prefixCls, "-title-area") },
                    title && React.createElement("span", { className: "".concat(prefixCls, "-title") }, renderElement(title)),
                    tag && React.createElement("span", { className: "".concat(prefixCls, "-tag") }, renderElement(tag))),
                subTitle && React.createElement("div", { className: "".concat(prefixCls, "-sub-title") }, renderElement(subTitle))))));
};
export default Header;
